var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRuler = function SvgRuler(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none",
    viewBox: "0 0 17 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m12.278.837 3.551 3.551L4.387 15.83l-3.55-3.551L12.276.837m0-.837a.83.83 0 0 0-.59.245L.245 11.687a.84.84 0 0 0 0 1.184l3.551 3.552a.836.836 0 0 0 1.183 0L16.42 4.98a.84.84 0 0 0 0-1.185L12.869.245A.84.84 0 0 0 12.278 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m4.895 8.218-.664.666 2.367 2.367.666-.664zm-1.328 1.33-.665.665 1.184 1.183.664-.664zm-1.329 1.329-.664.664 1.183 1.184.664-.664zM6.224 6.89l-.664.664L6.743 8.74l.666-.666zm1.33-1.329-.664.664L8.073 7.41l.665-.665zm1.329-1.329-.665.664 2.368 2.368.664-.665zm2.657-2.657-.664.664L12.06 3.42l.664-.663zm-1.328 1.328-.665.665L10.73 4.75l.664-.664z"
  })));
};
export default SvgRuler;